module.exports = __webpack_public_path__ + "static/square-bluesky-brands-solid-black-b939622227ea784dbd92d578fcd08f07.png";